import React from 'react';
import { Reveal } from './Reveal';
const points = [['😰', 'Arriving to class without knowing what activity to teach'], ['⏱️', 'Spending hours planning what could take minutes'], ['🤷', 'Not knowing how to connect art history without sounding boring'], ['📋', 'No clear assessments or rubrics aligned with the curriculum'], ['😓', 'Students always doing the same thing, lessons not evolving'], ['🌙', 'Still not ready for Monday by Sunday night']];
export function PainPointsSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-307">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-308">
        <h2 className="text-3xl font-black md:text-4xl" data-id="element-309">
          👉 Do You Recognize Yourself in These Situations?
        </h2>
        <p className="mt-4 text-brand-gray" data-id="element-310">
          If you said yes to any of these — this pack is for you.
        </p>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-311">
          {points.map(([emoji, text]) => <article key={text} className="flex items-center gap-4 rounded-2xl border border-black/[0.04] bg-brand-alt p-5 text-left shadow-sm" data-id="element-312">
              <span className="text-2xl" aria-hidden="true" data-id="element-313">
                {emoji}
              </span>
              <span className="text-sm font-semibold leading-snug" data-id="element-314">{text}</span>
            </article>)}
        </div>
        <p className="mt-12 font-serif text-2xl font-bold italic text-brand-red" data-id="element-315">
          And you deserve so much more than that →
        </p>
      </Reveal>
    </section>;
}